import React from 'react';
import { LoyaltyPoints } from './LoyaltyPoints';
import { FreeGiftBanner } from './FreeGiftBanner';
interface ProductInfoProps {
  product: {
    name: string;
    brand: string;
    price: number;
    originalPrice?: number;
    discount?: number;
    inStock: boolean;
    stockStatus: string;
    tags?: string[];
    loyaltyPoints?: number;
  };
  simplified?: boolean;
}
export function ProductInfo({
  product,
  simplified = false
}: ProductInfoProps) {
  return <div className="space-y-6" data-id="element-4999" data-mp="1r9o8ub5a5jb3">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm md:p-5" data-id="element-5000" data-mp="1w30v4emhle0o">
        <div className="mb-2 flex flex-wrap items-center gap-2" data-id="element-5001" data-mp="1ibck6enz4vla">
          <span className="text-sm font-semibold uppercase tracking-wide text-gray-900" data-id="element-5002" data-mp="1icxcdxmtg2fz">{product.brand}</span>
          <a href="#" className="text-xs text-brand hover:underline" data-id="element-5003" data-mp="1n82vypsqx50w">View More</a>
          <span className={`ml-auto whitespace-nowrap text-xs font-bold ${product.inStock ? 'text-brand' : 'text-red-600'}`} data-id="element-5004" data-mp="18doo9lemti1j">{product.stockStatus}</span>
        </div>
        <h1 className="mb-3 text-xl font-semibold leading-tight text-gray-900 md:text-2xl" data-id="element-5005" data-mp="31srmfn4y5ltb">{product.name}</h1>
        <div className="mb-4" data-id="element-5006" data-mp="2wtoik60pdlmx">
          <div className="mb-2 flex items-baseline gap-3" data-id="element-5007" data-mp="2wwki1ys78idh">
            <span className="text-3xl font-bold text-red-600" data-id="element-5008" data-mp="3at7rv259330t">SAR {product.price.toFixed(2)}</span>
            {product.originalPrice && <span className="text-lg text-gray-400 line-through" data-id="element-5009" data-mp="36tfe8b1026ol">SAR {product.originalPrice.toFixed(2)}</span>}
          </div>
          {product.discount && product.discount > 0 && <span className="inline-block rounded-full bg-red-100 px-3 py-1 text-sm font-bold text-red-700" data-id="element-5010" data-mp="2e51ftu6018ci">Save {product.discount}%</span>}
        </div>
        {!simplified && <>
          <FreeGiftBanner data-id="element-5011" data-mp="2n45031gwjtsl" />
          {product.loyaltyPoints && <div className="mt-4 border-t border-gray-200 pt-4" data-id="element-5012" data-mp="2n3dbialq2wbt"><LoyaltyPoints points={product.loyaltyPoints} data-id="element-5013" data-mp="1zean8jwl258c" /></div>}
        </>}
      </div>
    </div>;
}